module.exports = __webpack_public_path__ + "img/seifs.2d404552.svg";